"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const styleOverrides = {
  horizontal: {
    paddingLeft: 15,
    paddingRight: 15,
    '&:first-of-type': {
      paddingLeft: 0
    },
    '&:last-of-type': {
      paddingRight: 0
    }
  }
};
var _default = exports.default = {
  styleOverrides
};
